import IPatientInfoSliceReducers from 'Views/FlexPayV2/types/store/patientInfoSlice/patientInfoSliceReducers';
import getPatientSliceData from './patientInfoSliceData';

// Note: in each action one data should be updated, not multiple

const getPatientSliceReducers = (): IPatientInfoSliceReducers => ({
  setPatientInfoLoading: (state, action) => {
    state.patientInfoLoading = action.payload;
  },
  setPatientInfo: (state, action) => {
    state.patientVO = action.payload;
  },
  updateInvoiceVO(state, { payload: updatedInvoiceVO }) {
    const invoiceId = updatedInvoiceVO.id;
    state.patientVO.invoices[invoiceId] = {
      ...state.patientVO.invoices[invoiceId],
      ...updatedInvoiceVO,
    };
  },
  resetStore() {
    return getPatientSliceData();
  },
});

export default getPatientSliceReducers;
